<template>
    <div class="centers">
        <template>
            <el-table :data="tableData" border v-loading="loading">
                <el-table-column label="Date" prop="create_date"></el-table-column>
                <el-table-column label="Transaction ID" prop="order_id"></el-table-column>
                <el-table-column label="Transaction amount(USD)" prop="currency_value"></el-table-column>
                <el-table-column label="Exchange rate" prop="currencies_present_rate">
                    <template slot="header">
                        Exchange rate
                        <el-tooltip placement="top">
                            <div slot="content">
                                <span>caption</span>
                                <br>
                                <span>Exchange rate records the exchange rate at the time the replenishment order was
                                    created</span>
                            </div>
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <el-table-column label="Settled amount" prop="payment_account">
                    <template slot="header">
                        Settled amount
                        <el-tooltip placement="top">
                            <div slot="content">
                                <span>caption</span>
                                <br>
                                <span>The amount to be paid is the sum added to the customer's balance</span>
                            </div>
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </template>
                    <!-- <template slot-scope="scope">
                        <span v-if="scope.row.payment_status==='PD'">{{scope.row.currency_value}}</span>
                    </template> -->
                </el-table-column>
                <el-table-column label="Status" prop="status">
                    <template slot-scope="scope">
                        <span class="yellow" v-if="scope.row.payment_status==='PU'">Pending</span>
                        <span class="caramel" v-else-if="scope.row.payment_status==='PS'">Paying</span>
                        <span class="blue" v-else-if="scope.row.payment_status==='PD'">Success</span>
                        <span class="gray" v-else-if="scope.row.payment_status==='PC'">Expired</span>
                    </template>
                </el-table-column>
                <el-table-column label="Operation" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button style="padding: 6px;" type="text" icon="iconfont icon-meiyuan"
                            @click="goPay(scope.row)" v-if="scope.row.payment_status==='PU'">付款</el-button>
                        <span type="text" v-else-if="scope.row.status!=='Pending'">/</span>
                    </template>
                </el-table-column>
            </el-table>
        </template>
        <!-- 分页 -->
        <div class="block" style="text-align: center;margin-top:2em">
            <el-pagination @size-change="handelSizechange" background @current-change="handelCurrentChange"
                :current-page="pageNum" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="totalcount">
                <!-- 总条数this.totalcount=数据传过来的数量 -->
            </el-pagination>
        </div>
        <!-- 充值回调弹窗 -->
        <!-- <el-dialog title="流水详情" :visible.sync="detailVisible" :close-on-click-modal="false" width="800px"> -->
        <el-dialog :visible.sync="rechargeOK" :close-on-click-modal="false" width="400px">
            <div class="rechargePop">
                <div v-if="rechargeSuccess">
                    <i class="iconfont icon-52"
                        style="font-size:100px; color:#91c0ea; display:inline-block; padding-bottom: 12px;"></i>
                    <p>Successful payment!</p>
                </div>
                <div v-else-if="!rechargeSuccess">
                    <i class="iconfont icon-iconfontgantanhao"
                        style="font-size:90px; color:#ff9900; display:inline-block; padding-bottom: 12px;"></i>
                    <p>Payment failed!</p>
                    <p style="line-height:40px;color:#ff9900;">Failure reason : {{failureReason}}</p>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { getCustomerBill, docheckout } from '../api/finance'
import { getItem1, removeItem1 } from '../../utils/locstorage'
import { removeKey } from '../../utils/sessionStorage'
import store from '@/store'
import { paypal } from '../api/user'
import { getToken } from '../../utils/auth'
import { getChartFree } from '../../views/api/home'

export default {
  data () {
    return {
      rechargeOK: false,
      rechargeSuccess: false,
      failureReason: 'Payment timeout',
      tableData: [

      ],
      customer_id: '',
      pageNum: 1,
      pageSize: 10,
      totalcount: 0,
      loading: false
    }
  },
  created () {
    if (store.getters.shopTokenuser != undefined) {
      let user = store.getters.shopTokenuser
      this.customer_id = user.customer_id
    }
    // 刷新余额信息
    this.getFree()
    // 验证充值状态
    if (getItem1('play')) {
      if (JSON.parse(getItem1('play')).orderId) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0,0, 0,.7)'
        })
        const params = {
          orderId: JSON.parse(getItem1('play')).orderId,
          token: JSON.parse(getItem1('play')).token,
          payerId: JSON.parse(getItem1('play')).PayerID
        }
        docheckout(params).then(response => {
          this.rechargeOK = true
          if (response.data.ask === 1) {
            this.rechargeSuccess = true
            this.getFree()
          } else {
            this.rechargeSuccess = false
          }
          removeItem1('play')
          loading.close()
        }).catch(err => {
          removeItem1('play')
          console.log(err)
          loading.close()
        })
      } else {
        removeItem1('play')
        this.rechargeOK = true
        this.rechargeSuccess = false
      }
    }
    this.getList()
  },
  methods: {
    getFree () {
      getChartFree({ customer_id: this.customer_id }).then(response => {
        console.log(response)
        // 存储余额
        // setKey('balance','￥9568.6');
        removeKey('balance')
        if (response.data.ask === 1 && response.data.data) {
          // this.balance = response.data.data.balance;
          // this.shipfee = response.data.data.shipfee;
          // if(this.balance>0){
          //     this.arrears = false;
          // }
          // 更新余额
          // store.dispatch('Recharge',true);
          store.dispatch('updateBalance', response.data.data.balance)
          // setKey('balance',this.balance);
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getList () {
      const params = {
        page: this.pageNum,
        pageSize: this.pageSize
      }
      this.loading = true
      getCustomerBill(params).then(response => {
        if (response.data.ask === 1) {
          this.tableData = response.data.data
          this.tableData.forEach((value, index) => {
            if (value.payment_status === 'PD') {
              value.payment_account = (parseFloat(value.real_money) - parseFloat(value.real_payfee)).toFixed(2)
            } else {
              value.payment_account = ''
            }
          })
          this.totalcount = parseInt(response.data.total)
        } else {
          this.tableData = []
          this.totalcount = 0
        }
        this.loading = false
      }).catch(err => {
        console.log(err)
        this.loading = false
      })
    },
    handelSizechange (pageSize) { // 改变每页数据量
      this.pageSize = pageSize
      this.getList()
    },
    handelCurrentChange (pageNum) { // 切换页码
      this.pageNum = pageNum
      this.getList()
    },
    // 充值
    goPay (item) {
      const params = {
        currency_code: 'USD',
        amount: parseInt(item.currency_value),
        order_id: item.order_id
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0,0, 0,.7)'
      })
      paypal(params).then(response => {
        if (response.data.ask === 1 && response.data.approve_url) {
          window.top.location.href = response.data.approve_url
          // loading.close();
          // window.open (response.data.approve_url, 'newwindow', 'left=410,height=610, width=860, top=200,  toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no')
        } else if (response.data.ask === 0 && response.data.msg) {
          loading.close()
        }
      }).catch(err => {
        console.log(err)
        loading.close()
      })
    }
  }
}
</script>
<style scoped>
    .centers {
        /* text-align: left; */
        margin-top: 20px;
        padding: 20px;
        border: 1px solid #DCDFE6;
    }

    .yellow {
        color: #cf9236;
    }

    .blue {
        color: #5daf34;
    }

    .gray {
        color: #82848a;
    }

    .caramel {
        color: #b4a7d6;
    }

    .rechargePop {
        padding-top: 10px;
        min-height: 200px;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/Finance/rechargeOrder.vue